export const limitLength = (name, length = 17) => {
    if (!name) return '';

    return `${name.substring(0, length)}${name.length > length ? '...' : ''}`;
};
